/**
 * Created by afuhr on 30.08.2016.
 */
/**
 * Created by afuhr on 27.05.2016.
 */
import {Injectable} from "@angular/core";
import {VisbosService} from "../../core/visbos-core/graphql/visbos.service";
import gql from "graphql-tag";
import {Observable} from "rxjs/Observable";
import {Vehicle} from "../model/vehicle.type";
import {Apollo, ApolloQueryObservable} from "apollo-angular";
import {NgRedux} from "@angular-redux/store";
import {IAppState} from "../../shared/redux-store";
import {SessionActions} from "../../shared/actions";
import {accountFragments} from '../../crm/services/accounting-unit.service';

export const fleetFragments = {
  vehicle: gql`
    fragment VehicleFields on Vehicle {
      cuid, label, is_editable
      license_plate
      identities {
        cuid label is_editable
        ean ean_type
      }
      administration_unit {
        cuid label
      }
      account {...AccountFields}
    }
    ${accountFragments.account}
  `
};

export const fetchVehiclesQuery = gql`
  query FetchVehiclesQuery($adminUnitCuid: String) {
    vehicles(administration_unit_cuid: $adminUnitCuid) {
      ...VehicleFields
    }
  }
  ${fleetFragments.vehicle}
`;

export const UpdateVehicleMutation = gql`
  mutation UpdateVehicle($cuid: String!, $data: VehicleInput!) {
    updateVehicle(cuid:$cuid, data: $data) {
      ...VehicleFields
    }
  }
  ${fleetFragments.vehicle}
`;

export const CreateVehicleMutation = gql`
  mutation CreateVehicle($data: VehicleInput!) {
    createVehicle(data: $data) {
      ...VehicleFields
    }
  }
  ${fleetFragments.vehicle}
`;

export const DeleteVehicleMutation = gql`
  mutation DeleteVehicle($cuid: String!) {
    deleteVehicle(cuid: $cuid)
  }
`;

export interface FetchVehiclesResult {
  vehicles: Vehicle[]
}

@Injectable()
export class FleetService extends VisbosService {


  constructor(apollo: Apollo, ngRedux: NgRedux<IAppState>, sessionActions: SessionActions) {
    super(apollo, ngRedux, sessionActions);
  }

  fetchVehicles(adminUnitCuid?: string | Observable<string>): ApolloQueryObservable<FetchVehiclesResult> {
    return this.fetchItems({
      query: fetchVehiclesQuery,
      variables: {
        adminUnitCuid: adminUnitCuid || this.activeAdminUnitCuid$
      }
    });
  }

  createVehicle(vehicleData): Observable<any> {
    return this.mutate({
      mutation: CreateVehicleMutation,
      variables: {
        data: vehicleData
      },
      refetchQueries: ['FetchVehiclesQuery']
    });
  }

  updateVehicle(cuid: string, vehicleData): Observable<any> {
    return this.mutate({
      mutation: UpdateVehicleMutation,
      variables: {
        cuid: cuid,
        data: vehicleData
      }
    });
  }

  deleteVehicle(cuid: string): Observable<any> {
    return this.mutate({
      mutation: DeleteVehicleMutation,
      variables: {
        cuid: cuid
      },
      refetchQueries: ['FetchVehiclesQuery']
    });
  }

}



// WEBPACK FOOTER //
// ./src/app/fleet/services/fleet.service.ts